import { useState, React } from "react";
import { NavDropdown, Navbar, Nav, Container, Button } from "react-bootstrap";
import Logo from "../assets/img/logo.png";
import GSMA_Logo from "../assets/img/GSMA_logo.jpeg";
import "./MyNavbar.css"; // Import the custom CSS file
import { useNavigate } from "react-router-dom";

const MyNavbar = () => {
  const [showDropdown, setShowDropdown] = useState(null);
  const navigate = useNavigate(); // For navigation

  // Define handleNavClick function
  const handleNavClick = (sectionId) => {
    navigate("/");
    setTimeout(() => {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }, 0); // delay to ensure navigation happens before scrolling
  };

  return (
    <Navbar expand="lg" fixed="top" className="navigation-bar">
      <Container>
        <Navbar.Brand
          onClick={() => handleNavClick("home")}
          className="d-flex align-items-center"
        >
          <img
            src={Logo}
            alt="Digi-Touch Logo"
            width={61}
            className="brand-logo"
            style={{ cursor: "pointer" }}
          />
          <span className="fs-4 text-white ms-2">Digi-Touch</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto navigation-bar-2 pb-lg-0 pb-4">
            <Nav.Link
              onClick={() => handleNavClick("about-us")}
              className="text-center"
            >
              About
            </Nav.Link>

            <NavDropdown
              title="Messaging"
              id="id_messaging-dropdown"
              className="text-center"
              show={showDropdown === "id_messaging"}
              onMouseEnter={() => setShowDropdown("id_messaging")}
              onMouseLeave={() => setShowDropdown(null)}
              onClick={() => handleNavClick("id_messaging")}
            >
              <NavDropdown.Item onClick={() => handleNavClick("id_messaging")}>
                Wholesale Messaging
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleNavClick("id_messaging")}>
                Enterprise Messaging
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleNavClick("id_messaging")}>
                Number Intelligence
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              title="Voice"
              id="id_voice-dropdown"
              className="text-center"
              show={showDropdown === "id_voice"}
              onMouseEnter={() => setShowDropdown("id_voice")}
              onMouseLeave={() => setShowDropdown(null)}
              onClick={() => handleNavClick("id_voice")}
            >
              <NavDropdown.Item onClick={() => handleNavClick("id_voice")}>
                Wholesale Voice
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleNavClick("id_voice")}>
                Text To Speech
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleNavClick("id_voice")}>
                Voice Firewall
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
                title="Data"
                id="data-dropdown"
                className="text-center"
                show={showDropdown === "id_data"}
                onMouseEnter={() => setShowDropdown("id_data")}
                onMouseLeave={() => setShowDropdown(null)}
                onClick={() => handleNavClick("id_data")}
            >
              <NavDropdown.Item onClick={() => handleNavClick("id_data")}>
                Cross Connect
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleNavClick("id_data")}>
                Local Loops
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleNavClick("id_data")}>
                Data Center Utilisation
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
                title="Managed Services"
                id="mngservices-dropdown"
                className="text-center"
                show={showDropdown === "mngservices"}
                onMouseEnter={() => setShowDropdown("mngservices")}
                onMouseLeave={() => setShowDropdown(null)}
                onClick={() => handleNavClick("mngservices")}
            >
              <NavDropdown.Item onClick={() => handleNavClick("mngservices")}>
                SMS Monetisation
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleNavClick("mngservices")}>
                Mobile Intelligence
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleNavClick("mngservices")}>
                MNP/HLR Enablement
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleNavClick("mngservices")}>
                Wholesale SMS Platform
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleNavClick("mngservices")}>
                Network Penetration Testing
              </NavDropdown.Item>
            </NavDropdown>

            <Nav.Link
              onClick={() => handleNavClick("whyus")}
              className="text-center"
            >
              Why Us
            </Nav.Link>
          </Nav>

          <Nav className="contact-us-header">
            {/*<Button*/}
            {/*  className="navbar-contact-us-btn"*/}
            {/*  onClick={() => navigate("/contact")}*/}
            {/*>*/}
            {/*  Contact Us*/}
            {/*</Button>*/}
            <img
                src={GSMA_Logo}
            />
          </Nav>
        </Navbar.Collapse>

      </Container>
    </Navbar>
  );
};

export default MyNavbar;
